import styled from 'styled-components'

import { ButtonGroup as DefaultButtonGroup } from '@subaio/components'

export const ButtonGroup = styled(DefaultButtonGroup)`
	padding: 0 16px;
`
